import { useMemo } from 'react'
import cnames from 'classnames'
import { Button, Modal, ModalBody } from 'reactstrap'
import CloseModalButton from 'Shared/CloseModalButton'
import FontAwesomeIcon from 'Shared/FontAwesomeIcon/FontAwesomeIcon'

const ResultModal = ({ data, isOpen, toggle, tryAgain }) => {
  const result = data?.campground?.sendMembershipEmail
  const modalClasses = 'modal-lg p-4'
  const icon = useMemo(() => ({
    icon: result ? 'circle-check' : 'circle-xmark',
    className: cnames('mb-3', { 'text-success': result, 'text-danger': !result }),
  }), [result])

  return (
    <Modal className={modalClasses} centered isOpen={isOpen} toggle={toggle}>
      <ModalBody className="text-center">
        <div className="d-flex align-items-center modal-body-header mb-3">
          {!result && (
            <span className="fs-6 fw-medium">You don't have any active memberships</span>
          )}

          <CloseModalButton className="ms-auto" onClick={toggle} />
        </div>

        <FontAwesomeIcon icon={icon.icon} className={icon.className} size="xl" />

        {result ? (
          <>
            <p className="fs-4 fw-medium">Details sent to your email</p>

            <p className="text-muted">We've sent your active membership details to your email.</p>
          </>
        ) : (
          <>
            <p className="fs-4 fw-medium text-danger">Membership Required</p>

            <p className="text-muted">No active memberships found. Try another email.</p>

            <Button onClick={tryAgain} color="danger">Try another email</Button>
          </>
        )}
      </ModalBody>
    </Modal>
  )
}

export default ResultModal
